import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import lottie from 'lottie-web/build/player/lottie_light';
import originalAnimation from './assets/hand-tapping-highlight.json';

// Original artwork and tap keyframes by Phương Nguyễn, Lottie Simple License.
// Isolate the original hand and shadow from the sample text-selection UI.
export function TapCue({ x, y }: { x: number; y: number }) {
  const container = useRef<HTMLSpanElement>(null);
  useEffect(() => {
    if (!container.current) return;
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const animationData = structuredClone(originalAnimation);
    animationData.layers = animationData.layers.filter(layer => [1, 2].includes(layer.ind));
    const animation = lottie.loadAnimation({
      container: container.current,
      renderer: 'svg',
      loop: true,
      autoplay: !motion.matches,
      animationData,
      initialSegment: [37, 96],
      rendererSettings: { viewBoxSize: '125 20 150 170', preserveAspectRatio: 'xMidYMid meet' },
    });
    const updateMotion = () => {
      if (motion.matches) animation.goToAndStop(8, true);
      else animation.play();
    };
    animation.addEventListener('DOMLoaded', updateMotion);
    motion.addEventListener('change', updateMotion);
    return () => {
      motion.removeEventListener('change', updateMotion);
      animation.destroy();
    };
  }, []);
  return createPortal(
    <span className="guide-tap-cue" style={{ left: x - 22, top: y - 19 }} aria-hidden="true">
      <span className="guide-tap-contact" />
      <span ref={container} className="guide-hand-press" />
    </span>,
    document.body,
  );
}
